import React from "react";

type Project = {
  title: string;
  description: string;
  stack: string;
};

function Projects() {
  const projects: Project[] = [
    {
      title: "Portfolio Website",
      description:
        "Persönliche Website mit Routing, Tech-Style und Terminal-Page.",
      stack: "React • TypeScript • CSS",
    },
    {
      title: "Dashboard UI",
      description:
        "Ein futuristisches Dashboard mit Karten, Metriken und Navigation.",
      stack: "React • State • UI Design",
    },
    {
      title: "Code Playground",
      description: "Experimentelle Komponenten und Interaktionen im Nerd-Look.",
      stack: "Frontend • Components • Styling",
    },
  ];

  return (
    <section className="content-section">
      <h1 className="section-title">Projects</h1>

      <div className="project-grid">
        {projects.map((project) => (
          <article className="glass-card project-card" key={project.title}>
            <h3>{project.title}</h3>
            <p>{project.description}</p>
            <span>{project.stack}</span>
          </article>
        ))}
      </div>
    </section>
  );
}

export default Projects;
